export default __webpack_public_path__ + "static/media/psc-pleger.77a5c9b8.jpg";